<template>
<div class="ele-body">
  <el-card shadow="never">
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="5" :sm="12">
          <el-form-item label="手机号:">
            <el-input v-model.trim="table.where.mobile" maxlength="11" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="12">
          <el-form-item label="年级:">
            <treeselect v-model="table.where.gradeId" :options="GradeTree" :disable-branch-nodes="true" :disabled="!!table.where.classId" placeholder="请选择年级" :defaultExpandLevel="3" @input="handleGradeChange" :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                " />
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="12">
          <el-form-item label="班级:">
            <treeselect v-model="table.where.classId" :options="ClassTree" :disable-branch-nodes="true" :disabled="!!table.where.gradeId" placeholder="请选择所属班级" :defaultExpandLevel="4" @input="handleClassChange" :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                " />
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="12">
          <el-form-item label="审核级别:">
            <el-select v-model="table.where.type" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in levelList" :key="item" :value="item" :label="item == 1 ? '一级审核' : item == 2 ? '二级审核' : item == 3 ? '三级审核' : ''" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
            <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
    </div>
    <!-- 数据表格 -->
    <ele-data-table class="table" ref="table" :config="table" :choose.sync="choose" highlight-current-row>
      <template #default="{ index }">
        <el-table-column type="selection" width="45" align="center" fixed="left" />
        <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="teacherName" label="教师姓名" show-overflow-tooltip min-width="100" />
        <el-table-column prop="mobile" label="手机号" show-overflow-tooltip min-width="120">
          <template #default="{ row }">
            {{ row.list && row.list.length > 0 ? row.list[0].mobile : '' }}
          </template>
        </el-table-column>
        <el-table-column label="负责班级" min-width="350" show-overflow-tooltip>
          <template #default="{ row }">
            <div style="line-height: 28px;">
              <el-tag v-for="item in row.list" :key="item.id" size="small" type="info" style="margin-right: 8px; margin-bottom: 4px;">
                {{ item.branchName }} - {{ item.gradeName }} - {{ item.className }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="审核级别" show-overflow-tooltip min-width="100">
          <template #default="{ row }">
            {{ row.list && row.list.length > 0 ? (row.list[0].type == 1 ? '一级审核' : row.list[0].type == 2 ? '二级审核' : row.list[0].type == 3 ? '三级审核' : '') : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" align="center" :resizable="false">
          <template #default="{ row }">
            <el-link icon="el-icon-setting" type="primary" :underline="false" @click="editTeacher(row)" style="margin-right: 10px;">设置</el-link>
            <el-popconfirm title="确定要删除此教师的所有班级审核权限吗？" @onConfirm="removeTeacher(row)" class="ele-action">
              <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
            </el-popconfirm>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
  </el-card>
  <!-- 编辑弹窗 -->
  <el-dialog :title="editForm.isEdit ? '设置教师班级' : '添加审核人员'" :visible.sync="showEdit" width="400px" @closed="editForm = {}" :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
    <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
      <el-row :gutter="15">
        <el-col>
          <el-form-item label="选择班级:" prop="classIds">
            <treeselect v-model="editForm.classIds" :options="ClassTree" :disable-branch-nodes="true" placeholder="请选择所属班级" :defaultExpandLevel="4" :multiple="true" style="line-height: 20px" :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                " />
          </el-form-item>
          <el-form-item label="选择老师:" prop="teacherIds">
            <treeselect v-model="editForm.teacherIds" :options="deptTeacher" :disable-branch-nodes="true" placeholder="请选择老师" :defaultExpandLevel="2" :multiple="true" search-nested :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                " style="line-height: 20px" />
          </el-form-item>
          <el-form-item label="审核级别:" prop="type">
            <el-select v-model="editForm.type" placeholder="请选择">
              <el-option v-for="(item, index) in levelList" :key="item" :value="item" :label="item == 1 ? '一级审核' : item == 2 ? '二级审核' : item == 3 ? '三级审核' : ''" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="showEdit = false">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'; // 下拉树
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  saveAuditTeacherAndClassScope,
  deleteAuditTeacherAndClassScope,
  getAllClassTree,
  getAllDepartTeachers,
  getSchoolAuditLevel,
} from '@/config/api';

export default {
  name: 'AddExamineOne',
  components: {
    Treeselect
  },
  data() {
    return {
      table: {
        // 表格配置
        url: '/school/studentLeave/findAuditTeacherAndClassScopeByCondition',
        where: {
          type: null,
        },
        parseData(res) {
          if (res.resCode == 200) res.code = 0;
          // 保持按教师分组的数据结构
          res.count = res.data ? res.data.length : 0;
          res.data = res.data || [];
          return res;
        },
      },
      choose: [], // 表格选中数据
      showEdit: false, // 是否显示表单弹窗
      editForm: {}, // 表单数据
      editRules: {
        // 表单验证规则
        classIds: [{
          required: true,
          message: '请选择班级',
          trigger: 'change'
        }],
        teacherIds: [{
          required: true,
          message: '请选择老师',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择审核级别',
          trigger: 'change'
        }],
      },
      ClassTree: [], //班级树数据
      GradeTree: [], //年级树数据
      deptTeacher: [], //部门下老师数据
      where: {},
      levelList: [],
      // teacherCheckData:[],
    };
  },
  mounted() {
    this.querydeptTeacher(); // 查询部门下的老师
    this.queryClassTree(); //查询班级树
    this.querySchoolLevel(); // 查询学校审核等级
  },
  methods: {
    /* 编辑教师班级 */
    editTeacher(row) {
      console.log('编辑教师数据:', row.list);
      // 打开编辑弹窗，预填充该教师的信息
      this.editForm = {
        teacherIds: row.teacherId ? [row.teacherId] : [],
        classIds: row.list ? row.list.map(item => 'c' + item.classId) : [],
        type: row.list && row.list.length > 0 ? row.list[0].type : null,
        isEdit: true, // 标记为编辑模式
      };
      console.log('editForm.classIds:', this.editForm.classIds);
      this.showEdit = true;
    },
    /* 年级选择变化 */
    handleGradeChange(value) {
      if (value) {
        // 选择了年级，清空班级
        this.table.where.classId = null;
      }
    },
    /* 班级选择变化 */
    handleClassChange(value) {
      if (value) {
        // 选择了班级，清空年级
        this.table.where.gradeId = null;
      }
    },
    /* 保存编辑 */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true
          });

          // 处理班级ID，去掉前缀'c'
          const classIds = [...this.editForm.classIds];
          for (let i = 0; i < classIds.length; i++) {
            classIds[i] = classIds[i].substr(1);
          }

          let formData = new FormData();
          formData.append('classIds', classIds);
          formData.append('teacherIds', this.editForm.teacherIds);
          formData.append('type', this.editForm.type);
          formData.append('type', 1);

          saveAuditTeacherAndClassScope(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({
                type: 'success',
                message: res.data.resMsg
              });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          }).catch(() => {
            loading.close();
            this.$message.error('保存失败');
          });
        } else {
          return false;
        }
      });
    },
    /* 删除教师的所有班级审核权限 */
    removeTeacher(row) {
      const loading = this.$loading({
        lock: true
      });
      // 获取该教师所有班级的id，用逗号分隔
      const ids = row.list.map(item => item.id).join(',');

      let formData = new FormData();
      formData.append('ids', ids);
      deleteAuditTeacherAndClassScope(formData).then((res) => {
        loading.close();
        if (res.data.resCode == 200) {
          this.$message({
            type: 'success',
            message: res.data.resMsg
          });
          this.$refs.table.reload();
        } else {
          this.$message.error(res.data.resMsg);
        }
      });
    },
    /* 删除单个班级审核权限 */
    remove(row) {
      const loading = this.$loading({
        lock: true
      });
      let formData = new FormData();
      formData.append('id', row.id);
      deleteAuditTeacherAndClassScope(formData).then((res) => {
        loading.close();
        if (res.data.resCode == 200) {
          this.$message({
            type: 'success',
            message: res.data.resMsg
          });
          this.$refs.table.reload();
        } else {
          this.$message.error(res.data.resMsg);
        }
      });
    },
    /* 获取所有部门下的所有老师 树 */
    querydeptTeacher() {
      getAllDepartTeachers().then((res) => {
        if (res.data.resCode == 200) {
          this.deptTeacher = this.removeDuplicateTeachers(res.data.data);
        } else {
          this.$message.error(res.data.resMsg);
        }
      });
    },
    /* 移除重复的教师ID */
    removeDuplicateTeachers(data) {
      const seenIds = new Set();

      const filterNode = (node) => {
        if (!node) return null;

        // 如果有children，递归处理
        if (node.children && node.children.length > 0) {
          node.children = node.children
            .map(child => filterNode(child))
            .filter(child => child !== null);
        }

        // 如果当前节点是教师节点（有teacherId或者是叶子节点）
        // 检查ID是否重复
        if (seenIds.has(node.id)) {
          return null; // 重复的节点，过滤掉
        }

        seenIds.add(node.id);
        return node;
      };

      return data.map(item => filterNode(item)).filter(item => item !== null);
    },
    /* 查询班级树 */
    queryClassTree() {
      getAllClassTree().then((res) => {
        if (res.data.resCode == 200) {
          this.ClassTree.push(res.data.data);
          this.deleteChildren(this.ClassTree);

          // 生成年级树（过滤掉班级层级）
          this.GradeTree.push(this.filterGradeTree(JSON.parse(JSON.stringify(res.data.data))));
        } else {
          this.$message.error(res.data.resMsg);
        }
      });
    },
    // 过滤出年级树，移除班级层级
    filterGradeTree(data) {
      if (data.children && data.children.length > 0) {
        data.children = data.children.map(child => {
          // 如果是班级层级（orgType === 4），则过滤掉
          if (child.orgType === 4) {
            return null;
          }
          // 递归处理子节点
          return this.filterGradeTree(child);
        }).filter(Boolean); // 移除null值

        // 如果处理后children为空，删除children属性
        if (data.children.length === 0) {
          delete data.children;
        }
      }
      return data;
    },
    // 循环数组 children为空时删除 且部系年级下无children时禁用
    deleteChildren(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          if (data[i].children.length) {
            this.deleteChildren(data[i].children);
          } else {
            if (data[i].orgType !== 4) {
              delete data[i].children;
              data[i].isDisabled = true;
            }
          }
        }
      }
      return data;
    },
    // 查询学校审核等级
    querySchoolLevel() {
      getSchoolAuditLevel().then((res) => {
        if (res.data.resCode == 200) {
          if (res.data.data.auditLevel == 1) {
            this.levelList = [1];
          } else if (res.data.data.auditLevel == 2) {
            this.levelList = [1, 2];
          } else if (res.data.data.auditLevel == 3) {
            this.levelList = [1, 2, 3];
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.ele-block>>>.el-upload,
.ele-block>>>.el-upload-dragger {
  width: 100%;
}
</style>
